import { useQuery } from "@apollo/client";
import { GET_CATEGORIES } from "./queries";

export const useGetCategories = () => {
  const { data, error, loading } = useQuery(GET_CATEGORIES);

  return {
    data,
    error,
    loading
  };
};
